module.exports = __webpack_public_path__ + "img/card_feature_1_grand_cherokee.82c3499a.jpg";